import type { EditorThemeClasses } from 'lexical';

import './TermsTheme.css';

const theme: EditorThemeClasses = {
    autocomplete: 'TermsTheme__autocomplete',
    blockCursor: 'TermsTheme__blockCursor',
    characterLimit: 'TermsTheme__characterLimit',
    code: 'TermsTheme__code',
    codeHighlight: {
        atrule: 'TermsTheme__tokenAttr',
        attr: 'TermsTheme__tokenAttr',
        boolean: 'TermsTheme__tokenProperty',
        builtin: 'TermsTheme__tokenSelector',
        cdata: 'TermsTheme__tokenComment',
        char: 'TermsTheme__tokenSelector',
        class: 'TermsTheme__tokenFunction',
        'class-name': 'TermsTheme__tokenFunction',
        comment: 'TermsTheme__tokenComment',
        constant: 'TermsTheme__tokenProperty',
        deleted: 'TermsTheme__tokenProperty',
        doctype: 'TermsTheme__tokenComment',
        entity: 'TermsTheme__tokenOperator',
        function: 'TermsTheme__tokenFunction',
        important: 'TermsTheme__tokenVariable',
        inserted: 'TermsTheme__tokenSelector',
        keyword: 'TermsTheme__tokenAttr',
        namespace: 'TermsTheme__tokenVariable',
        number: 'TermsTheme__tokenProperty',
        operator: 'TermsTheme__tokenOperator',
        prolog: 'TermsTheme__tokenComment',
        property: 'TermsTheme__tokenProperty',
        punctuation: 'TermsTheme__tokenPunctuation',
        regex: 'TermsTheme__tokenVariable',
        selector: 'TermsTheme__tokenSelector',
        string: 'TermsTheme__tokenSelector',
        symbol: 'TermsTheme__tokenProperty',
        tag: 'TermsTheme__tokenProperty',
        url: 'TermsTheme__tokenOperator',
        variable: 'TermsTheme__tokenVariable',
    },
    embedBlock: {
        base: 'TermsTheme__embedBlock',
        focus: 'TermsTheme__embedBlockFocus',
    },
    hashtag: 'TermsTheme__hashtag',
    heading: {
        h1: 'TermsTheme__h1',
        h2: 'TermsTheme__h2',
        h3: 'TermsTheme__h3',
        h4: 'TermsTheme__h4',
        h5: 'TermsTheme__h5',
        h6: 'TermsTheme__h6',
    },
    hr: 'TermsTheme__hr',
    hrSelected: 'TermsTheme__hrSelected',
    image: 'editor-image',
    indent: 'TermsTheme__indent',
    inlineImage: 'inline-editor-image',
    layoutContainer: 'TermsTheme__layoutContainer',
    layoutItem: 'TermsTheme__layoutItem',
    link: 'TermsTheme__link',
    list: {
        checklist: 'TermsTheme__checklist',
        listitem: 'TermsTheme__listItem',
        listitemChecked: 'TermsTheme__listItemChecked',
        listitemUnchecked: 'TermsTheme__listItemUnchecked',
        nested: {
            listitem: 'TermsTheme__nestedListItem',
        },
        olDepth: [
            'TermsTheme__ol1',
            'TermsTheme__ol2',
            'TermsTheme__ol3',
            'TermsTheme__ol4',
            'TermsTheme__ol5',
        ],
        ul: 'TermsTheme__ul',
    },
    ltr: 'TermsTheme__ltr',
    mark: 'TermsTheme__mark',
    markOverlap: 'TermsTheme__markOverlap',
    paragraph: 'TermsTheme__paragraph',
    quote: 'TermsTheme__quote',
    rtl: 'TermsTheme__rtl',
    specialText: 'TermsTheme__specialText',
    tab: 'TermsTheme__tabNode',
    table: 'TermsTheme__table',
    tableAddColumns: 'TermsTheme__tableAddColumns',
    tableAddRows: 'TermsTheme__tableAddRows',
    tableAlignment: {
        center: 'TermsTheme__tableAlignmentCenter',
        right: 'TermsTheme__tableAlignmentRight',
    },
    tableCell: 'TermsTheme__tableCell',
    tableCellActionButton: 'TermsTheme__tableCellActionButton',
    tableCellActionButtonContainer:
        'TermsTheme__tableCellActionButtonContainer',
    tableCellHeader: 'TermsTheme__tableCellHeader',
    tableCellResizer: 'TermsTheme__tableCellResizer',
    tableCellSelected: 'TermsTheme__tableCellSelected',
    tableFrozenColumn: 'TermsTheme__tableFrozenColumn',
    tableFrozenRow: 'TermsTheme__tableFrozenRow',
    tableRowStriping: 'TermsTheme__tableRowStriping',
    tableScrollableWrapper: 'TermsTheme__tableScrollableWrapper',
    tableSelected: 'TermsTheme__tableSelected',
    tableSelection: 'TermsTheme__tableSelection',
    text: {
        bold: 'TermsTheme__textBold',
        capitalize: 'TermsTheme__textCapitalize',
        code: 'TermsTheme__textCode',
        highlight: 'TermsTheme__textHighlight',
        italic: 'TermsTheme__textItalic',
        lowercase: 'TermsTheme__textLowercase',
        strikethrough: 'TermsTheme__textStrikethrough',
        subscript: 'TermsTheme__textSubscript',
        superscript: 'TermsTheme__textSuperscript',
        underline: 'TermsTheme__textUnderline',
        underlineStrikethrough: 'TermsTheme__textUnderlineStrikethrough',
        uppercase: 'TermsTheme__textUppercase',
    },
};

export default theme;
